export default __webpack_public_path__ + "static/media/diplomatIcon.544b6126.svg";